
    <b4a-product-supplier-form
      [supplier]="supplier"
      [countries]="countries"
      [languages]="languages"
      [onSubmit]="onSubmit.bind(this)"
    ></b4a-product-supplier-form>


// WEBPACK FOOTER //
// ./src/app/product/supplier-detail-page.container.ts.SupplierDetailPageComponent.html